<template>
  <div>
    <div class="d-flex" v-if="!hideOperationHours">
      <span
        class="font-14-400"
        :class="{
          'green--text': placeIsOpen,
          'red--text': !placeIsOpen,
        }"
        >{{ placeIsOpen ? "OPEN" : "CLOSED" }}</span
      >
      <span class="font-14-400">[[Hours]]</span>
    </div>
    <div class="schedule-container mt-5">
      <div
        class="schedule-container__header"
        :class="{ 'bordered-header': !scheduleExpanded }"
      >
        <div class="d-flex align-center">
          <div class="font-12-600 flex-grow-1 text-center">
            {{ headerText }}
          </div>
          <div>
            <v-btn depressed icon @click="scheduleExpanded = !scheduleExpanded">
              <v-icon color="#fff">{{ arrowToggleDirection }}</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
      <v-expand-transition>
        <div class="schedule-container__body" v-if="scheduleExpanded">
          <div class="py-10 d-flex w-100 flex-column">
            <div class="d-flex flex-column mt-5">
              <p class="font-14-400 mb-0" v-if="windows.length > 0">
                {{ scheduleText }}:
              </p>
              <p
                v-for="(window, index) in windows"
                :key="`window_${index}`"
                class="text-uppercase font-14-400 color-dark-400"
              >
                <span class="format-window">{{ formatWindow(window) }}</span>
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      @click="removeWindow(index)"
                      v-on="on"
                      class="red--text text--lighten-3"
                    >
                      <v-icon color="error" class="red--text text--lighten-3"
                        >mdi-delete-forever-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>{{
                    $i18n(
                      "order.actions.removeSchedule",
                      "Remove this schedule"
                    )
                  }}</span>
                </v-tooltip>
              </p>
              <!-- Date and time picker -->
              <div class="d-flex flex-column" v-if="scheduleExpanded">
                <v-date-picker
                  color="primary"
                  dense
                  fullWidth
                  showCurrent
                  type="date"
                  flat
                  v-model="startDate"
                  :min="currentDate"
                  class="flat-date-picker mx-0"
                ></v-date-picker>
                <div v-if="showHours" class="grid grid-columns-center mt-5">
                  <div class="d-flex flex-column">
                    <p>From</p>
                    <vue-timepicker
                      v-model="startTime"
                      :format="startTimeFormat"
                      drop-direction="up"
                      :hour-range="[[fromStartHour, endHour]]"
                    >
                      <template v-slot:icon>
                        <v-icon color="primary"> mdi-clock-outline </v-icon>
                      </template>
                    </vue-timepicker>
                  </div>
                  <div class="d-flex flex-column">
                    <p>To</p>
                    <vue-timepicker
                      v-model="endTime"
                      :format="startTimeFormat"
                      drop-direction="up"
                      :hour-range="[[toStartHour, endHour]]"
                    >
                      <template v-slot:icon>
                        <v-icon color="primary"> mdi-clock-outline </v-icon>
                      </template>
                    </vue-timepicker>
                  </div>
                </div>
                <v-btn
                  block
                  color="primary"
                  depressed
                  class="text-uppercase mt-5"
                  :disabled="!validEntry"
                  @click="addWindow"
                  >Save</v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </v-expand-transition>
    </div>
  </div>
</template>

<script type="text/babel">
import _map from "lodash/map";
import _find from "lodash/find";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import VueTimepicker from "vue2-timepicker";
import moment from "moment";
import "moment-timezone";
import {
  VExpandTransition,
  VBtn,
  VDatePicker,
  VTooltip,
  VIcon,
} from "vuetify/lib";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  name: "components-orders-creare-components-schedule_pickup_dropoff_address-index",
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.windows = newValue || [];
      },
    },
  },
  props: {
    /**
     * @model
     */
    value: {
      default: undefined,
    },
    name: undefined,
    hideOperationHours: {
      default() {
        return false;
      },
    },
    showHours: {
      default() {
        return true;
      },
    },
    initialHeader: undefined,
  },
  data() {
    return {
      scheduleExpanded: false,
      scheduleType: undefined,
      startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      startTime: {
        hh: "7",
        a: "am",
      },
      endTime: {
        hh: "5",
        a: "pm",
      },
      startTimeFormat: "hh a",
      windows: [],
      showSchedule: false,
    };
  },
  methods: {
    addWindow() {
      let window = {
        start: undefined,
        end: undefined,
      };

      if (this.showHours) {
        let fromHour =
          this.startTime.a === "am"
            ? parseInt(this.startTime.hh)
            : parseInt(this.startTime.hh) + 12;
        let toHour =
          this.endTime.a === "am"
            ? parseInt(this.endTime.hh)
            : parseInt(this.endTime.hh) + 12;
        if (toHour <= fromHour) {
          return;
        }

        let timeFormat = `${this.startTime.hh}:00 ${this.startTime.a}`;
        let endTimeFormat = `${this.endTime.hh}:00 ${this.endTime.a}`;
        let fullStartTime = moment(
          this.startDate + " " + timeFormat,
          "YYYY-MM-DD HH:mm a"
        ).format(`YYYY-MM-DDTHH:mmZ`);
        let fullEndTime = moment(
          this.startDate + " " + endTimeFormat,
          "YYYY-MM-DD HH:mm a"
        ).format(`YYYY-MM-DDTHH:mmZ`);
        window.start = fullStartTime;
        window.end = fullEndTime;
      } else {
        let fullStartTime =
          moment(this.startDate + " 00:00", "YYYY-MM-DD HH:mm").format(`YYYY-MM-DDTHH:mmZ`);
        let fullEndTime =
          moment(this.startDate + " 23:59", "YYYY-MM-DD HH:mm").format(`YYYY-MM-DDTHH:mmZ`);
        window.start = fullStartTime;
        window.end = fullEndTime;
      }
      this.windows.push(window);
      this.$emit("input", this.windows);
    },
    formatWindow(window) {
      let monthDay = moment(window.start).format("MMMM Do");
      if (this.showHours) {
        let hourFrom = moment(window.start).format("hhA");
        let hourTo = moment(window.end).format("hhA");
        return `${monthDay} ${hourFrom} - ${hourTo}`;
      }
      return `${monthDay}`;
    },
    removeWindow(index) {
      this.windows.splice(index, 1);
      this.$emit("input", this.windows);
    },
  },
  computed: {
    validEntry() {
      if (this.showHours) {
        let fromHour =
          this.startTime.a === "am"
            ? parseInt(this.startTime.hh)
            : parseInt(this.startTime.hh) + 12;
        let toHour =
          this.endTime.a === "am"
            ? parseInt(this.endTime.hh)
            : parseInt(this.endTime.hh) + 12;
        return !isNaN(fromHour) && !isNaN(toHour) && fromHour < toHour;
      }
      return true;
    },
    currentDate() {
      return moment().format("YYYY-MM-DD");
    },
    currentHour() {
      return moment().hours();
    },
    fromStartHour() {
      return moment(this.startDate).isAfter(moment(this.currentDate)) ||
        this.currentHour < 7
        ? 7
        : this.currentHour + 1;
    },
    toStartHour() {
      let startHour =
        this.startTime.a === "am"
          ? parseInt(this.startTime.hh)
          : parseInt(this.startTime.hh) + 12;
      return (startHour || this.fromStartHour) + 1;
    },
    endHour() {
      return 18;
    },
    arrowToggleDirection() {
      return this.scheduleExpanded ? "mdi-chevron-up" : "mdi-chevron-down";
    },
    headerText() {
      let wlength = this.windows.length;
      if (wlength === 0) {
        return this.initialHeader || `Schedule ${this.name}`;
      } else if (wlength === 1) {
        return `change/add ${this.name} - ${this.formatWindow(
          this.windows[0]
        )}`;
      } else {
        return `change/add ${this.name} - ${wlength} time windows`;
      }
    },
    scheduleText() {
      if (this.scheduleType === "schedule") {
        let type = this.isFirstAddress ? "Pick up" : "Drop off";
        return `${type} window`;
      }
      return this.isFirstAddress ? "Pick Up" : "Drop Off";
    },
    placeIsOpen() {
      return true;
    },
    isFirstAddress() {
      return this.name == "Pickup";
    },
    isLastAddress() {
      return this.name == "Drop-Off";
    },
    addressLabel() {
      return this.name + " Address";
    },
    notesLabel() {
      return this.name + " Directions";
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  components: {
    VueTimepicker,
    VExpandTransition,
    VBtn,
    VDatePicker,
    VTooltip,
    VIcon,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "~vue2-timepicker/dist/VueTimepicker.css";

.schedule-container {
  border: 1px solid var(--primary-color);
  border-radius: 4px;

  &__header {
    background: var(--primary-color);
    color: #fff;
    text-transform: uppercase;
    padding: 4px 8px;
    position: relative;
  }

  &__body {
    padding: 0 10px;

    .vue__time-picker {
      width: 100% !important;
    }
    .v-input--selection-controls {
      margin-top: 0 !important;
    }
  }
}

.bordered-header {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.flat-date-picker {
  box-shadow: unset !important;
  border: 1px solid var(--primary-color);
  border-radius: 0 0 5px 5px !important;
}

.format-window {
  min-width: 200px;
  display: inline-block;
}

.radio-schedule {
  margin-left: 25%;
}

::v-deep {
  .vue__time-picker input.display-time {
    width: 100% !important;
  }
  .vue__time-picker-dropdown ul li:not([disabled]).active,
  .vue__time-picker-dropdown ul li:not([disabled]).active:focus,
  .vue__time-picker-dropdown ul li:not([disabled]).active:hover,
  .vue__time-picker .dropdown ul li:not([disabled]).active,
  .vue__time-picker .dropdown ul li:not([disabled]).active:focus,
  .vue__time-picker .dropdown ul li:not([disabled]).active:hover {
    background: var(--primary-color);
  }
}
</style>
